import React from 'react';
import {NavLink} from 'react-router-dom';
import ceiasLogo from '../../assets/ceias_logo.svg';

import './styles.scss';

const Logo = () => {
  return (
    <NavLink to="/" className="Logo">
      <div className='desktop'>
        <img src={ceiasLogo} alt="CEIAS"/>
      </div>
    </NavLink>
  );
};

export default Logo;
